import { WidgetViewExtension } from '@blocksuite/std';
import { literal, unsafeStatic } from 'lit/static-html.js';

import { HIVE_SCROLL_ANCHORING_WIDGET } from './scroll-anchoring.js';

export * from './scroll-anchoring.js';

export const scrollAnchoringWidget = WidgetViewExtension(
  'hive:page',
  HIVE_SCROLL_ANCHORING_WIDGET,
  literal`${unsafeStatic(HIVE_SCROLL_ANCHORING_WIDGET)}`
);
